export default "__VITE_ASSET__D185B_8s__"